import script from "./MoleculeNavigationTabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeNavigationTabs.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeNavigationTabs.vue?vue&type=style&index=0&id=592aa70e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-592aa70e"]])

export default __exports__